'use strict';

namespace Core {

    export class ScModal {

        // bound
        open: boolean;
        disableBackdropClick: boolean;
        disableEscapeKeyDown: boolean;
        onClose: () => void;

        private element: JQuery;
        private container: JQuery;
        private backdrop: JQuery;
        private content: JQuery;

        private lastFocus: Element|null;

        private eventNamespace: string = `.${this.componentUtil.getRandomID('sc-c-modal-')}`;
        private lastContextOverflow: string;
        private repositioned: boolean = false;

        private visible: boolean = false;
        private animatingIn: boolean = false;
        private animatingOut: boolean = false;

        constructor (
            private $scope: ng.IScope,
            private componentUtil: TR.ComponentUtil,
            private animationUtil: any,
        ) {
        }

        init (element: ng.IAugmentedJQuery, content: JQuery, backdrop: JQuery): void {
            this.element = element;
            this.content = content;
            this.backdrop = backdrop;

            // for now, presume container is the body.
            // (this could become a param)
            this.container = $(document.body);

            if (this.element.parent() !== this.container) {
                this.repositioned = true;
                this.element.appendTo(this.container);
            }

            // decorate contents with additional properties
            this.content.attr('tabindex', '-1');
            this.content.attr('role', 'document');

            this.$scope.$on('$destroy', this.destroy);

            // watch open state
            this.$scope.$watch('m.open', (val) => {
                if (!_.isUndefined(val)) {
                    val ? this.handleOpen() : this.handleClose();
                }
            });
        }

        private handleOpen(): void {
            if (this.visible) {
                return;
            }

            // bind handlers
            _.forEach(this.bind, (handler) => {
                handler();
            });

            // animate the backdrop IN
            this.animatingIn = true; // applies class with transition
            this.visible = true;
            this.animationUtil.waitForTransition(this.backdrop).then((el) => {
                this.animatingIn = false;
                this.autoFocus();
            });
        }

        private handleClose(): void {
            if (!this.visible) {
                return;
            }

            // animate the backdrop OUT
            this.animatingOut = true; // applies class with transition
            this.animationUtil.waitForTransition(this.backdrop).then((el) => {
                this.animatingOut = false;
                this.visible = false;

                // unbind handlers
                _.forEach(this.unbind, (handler) => {
                    handler();
                });

                this.restoreLastFocus();
            });
        }

        private bind = {
            focus: () => {
                //$(document).on(`focus${this.eventNamespace}`, this.enforceFocus);
            },
            keydown: () => {
                $(document).on(`keydown${this.eventNamespace}`, this.handleDocumentKeyDown);
            },
            scrollLock: () => {
                // disable browser scroll bar
                this.lastContextOverflow = this.container.css('overflow');
                this.container.css('overflow', 'hidden');
            }
        };

        private unbind = {
            focus: () => {
                //$(document).off(this.eventNamespace);
            },
            keydown: () => {
                $(document).off(this.eventNamespace);
            },
            scrollLock: () => {
                // enable browser scroll bar
                this.container.css('overflow', this.lastContextOverflow);
                this.lastContextOverflow = '';
            }
        };

        private handleBackdropClick = (event) => {
            if (!this.disableBackdropClick) {
                this.onClose();
            }
        }

        private handleDocumentKeyDown = (event) => {
            let isEscape = (event.keyCode === 27);
            if (!isEscape) {
                return;
            }
            if (!this.disableEscapeKeyDown) {
                this.$scope.$apply(() => this.onClose());
            }
        }

        private autoFocus = () => {
            const currentActive = document.activeElement;
            if (!$.contains(this.content[0], currentActive)) {
                this.lastFocus = currentActive;
                this.content.focus();
            }
        }

        private restoreLastFocus = () => {
            if (this.lastFocus) {
                $(this.lastFocus).focus();
                this.lastFocus = null;
            }
        }

        // private enforceFocus = () => {
        //     console.log('enforceFocus');
        //
        //     // Prevent focus from leaving the modal
        //     const currentActive = document.activeElement;
        //     if (!$.contains(this.content[0], currentActive)) {
        //         console.log('preventing');
        //         this.content.focus();
        //     }
        // }

        private getBackdropClasses = () => {
            return {
                'u-fade-enter-active': this.animatingIn,
                'u-fade-exit-active': this.animatingOut,
                'u-transparent': !this.visible
            };
        }

        private destroy = () => {
            this.open && this.handleClose();
            this.repositioned && this.element.remove();
        }
    }

    angular
        .module('core')
        .directive('scModal', (): ng.IDirective => {

            return {
                scope: {},
                restrict: 'E',
                replace: true,
                transclude: true,
                controller: ScModal,
                controllerAs: 'm',
                bindToController: {
                    open: '=',
                    onClose: '&',
                    disableBackdropClick: '=',
                    disableEscapeKeyDown: '=',
                },
                template: `<div class="sc-c-modal" 
                                ng-class="{'u-invisible': !m.visible}">
                                <div class="sc-c-modal__backdrop" 
                                     ng-class="m.getBackdropClasses()"
                                     aria-hidden="true"
                                     ng-click="m.handleBackdropClick($event)" />
                           </div>`,
                link: (
                    scope: ng.IScope,
                    el: ng.IAugmentedJQuery,
                    attr: ng.IAttributes,
                    controller: ScModal,
                    transcludeFn
                ) => {

                    // transclude the content node directly to root element, so
                    // that it is a sibling of the backdrop node.
                    transcludeFn(scope, (contents: JQuery) => {
                        angular.forEach(contents, (node) => {
                            el.append(node);
                        });
                    });

                    const backdrop: JQuery = el.children().first();
                    const content: JQuery = el.children().last();

                    controller.init(el, content, backdrop);
                }
            };

        });
}

